<!-- // 重点澄清页面开发 -->
<template>
  <div class="EmphasisClarification CommonContentSingle-gray">
    <el-dialog title="测试报告" :visible.sync="centerDialogVisible" width="50%" center>
      <div style="background: rgba(225, 245, 233, 1);height: 40px;line-height: 40px;">
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;">姓名：{{ Paperhead.Name }}</span>
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;">性别：{{ Paperhead.Sex }}</span>
        <span style="margin-left: 20px; font-size: 14px; font-weight: 400;">单位：{{ Paperhead.DeptName }}</span>
      </div>
      <table style="width: 100%;" class="Paperhead">

        <tr style="width: 100%;height: 40px;line-height: 40px;background: rgba(245, 247, 250, 1);">
          <th width="25%">测试量表</th>
          <th width="25%">原始分</th>
          <th width="25%">标准分</th>
          <th width="25%">报告</th>
        </tr>

        <tr v-for="item in PaperList" :key="item.index" style="height: 40px; line-height: 40px; text-align: center;">
          <td width="25%">{{ item.PaperName }}</td>
          <td width="25%">{{ item.PaperScoreR }}</td>
          <td width="25%">{{ item.PaperScoreS }}</td>
          <td width="25%"> <span style="color: rgba(0, 136, 255, 1);padding: 20px;cursor: pointer;" @click="openReport(item.PaperResultID)">查看</span> </td>
        </tr>

      </table>
    </el-dialog>

    <el-dialog close="dialogs" title="上海海洋大学大学新生心理预警访谈记录表" :before-close="whandleClose"  :visible.sync="interviewVisible" center>

      <el-form :model="fieldObj" ref="ruleForm" label-width="180px" class="demo-ruleForm">

        <el-form-item label="访谈人：">
          <el-input v-model="Paperhead.Remark"  placeholder="请输入..." show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="日期:" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <div v-for="(item, index) in fieldArray"  :key="index"  :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{required: true, message: '请输入' + item.ShowName, trigger: 'blur'}]:[]">
              <el-input  type="textarea" maxlength="5000" v-model="item.FormValue" placeholder="请输入..." show-word-limit></el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item :label="item.ShowName"  class="ccc" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true, message: '请输入' + item.ShowName, trigger: 'blur'}]:[]" >
              <el-input maxlength="5000" type="textarea" rows="4" :placeholder="item.desc" v-model="item.FormValue" show-word-limit></el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item :prop="item.ShowName" :label="item.ShowName" :rules=" item.requiredOrNot == 2  ? [{required: true, message: '请选择' + item.ShowName, trigger: 'change'}]:[]" >
              <el-date-picker v-model="item.FormValue" :name="item.ShowName" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true, message: '请选择' + item.ShowName,trigger: 'change'}]:[]">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true,message: '请选择' + item.ShowName,trigger: 'change'}]:[]">
              <template v-for="child in item.Bobbies" style="margin-top: -20px;" >
                <el-radio v-bind:style="{ color: child.FontColor }" v-model="item.FormValue" :label="child.Value" >{{ child.Name }}</el-radio>
              </template>
              <el-form-item  style="display: inline-block;margin-left: 20px;" v-for="itmes in item.Bobbies" :key="itmes.index" >
                <el-input style="width: 300px;height: 80px;" type="textarea"  maxlength="5000" v-if="itmes.Display" v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true,message: '请选择' + item.ShowName,trigger: 'change'}]:[]">
              <el-checkbox-group  v-model="item.FormValue"  style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="(interviewVisible = false), wppgai()">返 回</el-button>
        <el-button v-if="SaveFlg == 1" type="primary" @click="submitForm()">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog close="dialogs" title="上海海洋大学大学新生心理预警访谈记录表" :visible.sync="interviewVisible2" :before-close="handleClose" width="70%"  center class="interviewVisible">
      <div style="text-align: center;">
        <el-button v-if="entity == '辅导员' && zhungtai =='已跟进'" type="primary" style="float: right;" @click="wdisabled = false">修改</el-button>
      </div>

      <el-form  :model="fieldObj" ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <el-form-item label="访谈人：">
          <el-input  v-model="Paperhead.Remark"  placeholder="请输入..." show-word-limit :disabled="wdisabled"></el-input>
        </el-form-item>

        <el-form-item label="日期:" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1"  type="date" :disabled="wdisabled" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <div  v-for="(item, index) in fieldArray"  :key="index"  :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item  :label="item.ShowName"  :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{required: true,message: '请输入' + item.ShowName,trigger: 'blur'}]:[]">
              <el-input  type="textarea"  maxlength="5000"  v-model="item.FormValue"  :disabled="wdisabled"  placeholder="请输入..."  show-word-limit></el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item  :label="item.ShowName"  class="ccc"  :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true,message: '请输入' + item.ShowName,trigger: 'blur'}]:[]">
              <el-input  type="textarea"  maxlength="5000"  rows="4" :disabled="wdisabled"  :placeholder="item.desc"  v-model="item.FormValue" show-word-limit></el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item  :prop="item.ShowName" :label="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{required: true,message: '请选择' + item.ShowName,trigger: 'change'}]:[]">
              <el-date-picker :disabled="wdisabled" v-model="item.FormValue" :name="item.ShowName" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true,message: '请选择' + item.ShowName,trigger: 'change'}]: []">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option :disabled="wdisabled" v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change'}]:[]" >
              <template v-for="child in item.Bobbies">
                <el-radio   :disabled="wdisabled"  v-bind:style="{ color: child.FontColor }" v-model="item.FormValue" :label="child.Value">{{ child.Name }}</el-radio>
              </template>
              
              <el-form-item style="display: inline-block;margin-left: 20px;" v-for="itmes in item.Bobbies" :key="itmes.index">
                <el-input type="textarea" style="width: 300px;height: 80px;"  maxlength="5000" :disabled="wdisabled" v-if="itmes.Display" v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{required: true,message: '请选择' + item.ShowName,trigger: 'change',}]:[]">
              <el-checkbox-group :disabled="wdisabled" v-model="item.FormValue" style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input :disabled="wdisabled" v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="(interviewVisible2 = false), wppgai()">取 消</el-button>
        <el-button v-if="!wdisabled" type="primary" @click="submitForm2()">修 改</el-button>
      </span>
    </el-dialog>

    <el-container>
      <el-header class="el-header" v-if="zhedie">
        <div class="boxs">
          <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="background-color: #fff;">

            <el-form-item label="综合查询">
              <el-input placeholder="账号/姓名/手机号"  v-model="ruleForm.UserID"></el-input>
            </el-form-item>

            <el-form-item label="预警后等级">
              <el-select v-model="ruleForm.General" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发布主题">
              <el-select  v-model="ruleForm.PublishSubject" placeholder="发布主题">
                <el-option v-for="item in GetSubjectPublishList" :key="item.PublishID" :label="item.PublishSubject" :value="item.PublishID">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="部门">
              <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID" filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable ></el-cascader>
            </el-form-item>

            <el-form-item label="来源">
              <el-select v-model="ruleForm.Source" placeholder="请选择">
                <el-option label="全部" value="-1">全部</el-option>
                <el-option label="测评结果" value="1">测评结果</el-option>
                <el-option label="手动加入" value="2">手动加入</el-option>
                <el-option label="随机生成" value="3">随机生成</el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="访谈状态">
              <el-select v-model="ruleForm.state" placeholder="请选择">
                <el-option  v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="访谈后等级">
              <el-select v-model="ruleForm.interview" placeholder="请选择">
                <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="测试进度">
              <el-select v-model="ruleForm.progress" placeholder="请选择">
                <el-option  v-for="item in options4"  :key="item.value"  :label="item.label"  :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="zhedies">折叠</el-button>
              <!-- <el-button type="primary" @click="wjsb">危机上报</el-button> -->
              <el-button type="primary" @click="ExportTableList(1)">导出</el-button>
              <el-popover v-if="!c3" placement="top"  width="160" v-model="visible">
                <p>所有“加入访谈”和“随机访谈”加入的学生将进入访谈跟进流程，且不可再次修改，请确认本学院的学生都完成测评后，再谨慎确认！谢谢</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="AddCombineResultStochastic">确定</el-button>
                </div>
                <!-- <el-button type="primary" slot="reference">确认访谈</el-button> -->
              </el-popover>
              <!-- <el-button v-if="!c3" type="primary" @click="Randomfun">随机访谈</el-button> -->
              <el-button type="primary" @click="resetForm()">重置</el-button>
              <el-button type="primary" :disabled = 'xaukm' @click="GettableList(1)">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-header>

      <el-header v-if="!zhedie">
        <el-button type="primary" @click="zhankai">展开</el-button>
      </el-header>

      <el-main class="el-main">
        <el-row>
          <el-col :span="22">
              <span style="padding: 5px;color: rgba(242, 75, 78, 1);background-color: rgba(242, 75, 78, 0.2);">
                <span style="margin-left: 20px;"> {{ $t('original.languages127') }}：{{ testcount.one }}/{{ interviewcount.one }}</span>
                <span style="margin-left: 20px;"> {{ $t('original.languages128') }}：{{ testcount.six }}/{{ interviewcount.six }}</span>
                <span style="margin-left: 20px;"> {{ $t('original.languages129') }}：{{ testcount.tow }}/{{ interviewcount.tow }}</span>
                <span style="margin-left: 20px;"> {{ $t('original.languages130') }}：{{ testcount.three }}/{{ interviewcount.three }}</span>
                <span style="margin-left: 20px;"> {{ $t('original.languages131') }}：{{ testcount.four }}/{{ interviewcount.four }}</span>
                <span style="margin-left: 20px;"> {{ $t('original.languages132') }}：{{ testcount.five }}/{{ interviewcount.five }}</span>
              </span>
            </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-table v-loading="loading" :data="tableList" stripe  ref="singleTable" highlight-current-row @current-change="handleCurrentChange" style="width: 100%;">
              <el-table-column label="序号" align="left" width="60px"><template slot-scope="scope" center>{{ scope.$index + 1 }}</template></el-table-column>
              <el-table-column property="UserID" label="学号" :center="true" width="160px"></el-table-column>
              <el-table-column property="RealName" label="姓名">
              </el-table-column>
              <el-table-column property="Sex" label="性别"> </el-table-column>
              <el-table-column property="Degree" label="学历">
              </el-table-column>
              <el-table-column property="DeptName" label="单位">
              </el-table-column>
              <el-table-column property="PublishSubject" label="发布主题">
              </el-table-column>
              <el-table-column align="center" label="预警后等级">
                <template slot-scope="scope" center>
                  <span :class="scope.row.Result == '轻度' ? 'mild' : scope.row.Result == '中度' ? 'moderate' : scope.row.Result == '重度' ? 'severe' : scope.row.Result == '良好' ? 'well': ''">{{ scope.row.Result }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="访谈后等级">
                <template slot-scope="scope" center>
                  <span :class="scope.row.InterviewConditionName == '轻度' ? 'mild' : scope.row.InterviewConditionName == '中度' ? 'moderate' : scope.row.InterviewConditionName == '较重' ? 'severe' : scope.row.InterviewConditionName == '良好' ? 'well' : scope.row.InterviewConditionName == '重度' ? 'urgency' : ''">
                    {{ scope.row.InterviewConditionName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column property="" label="建议">
                <template slot-scope="scope" center>
                  <el-popover v-if="scope.row.Suggest != '-'" placement="top-start" title="建议"  width="200" trigger="hover" :content="scope.row.ResultDetailZX" >
                    <div slot="reference">
                      <span :class=" scope.row.Suggest == '轻度' ||  scope.row.Suggest == '适当关注' ? 'mild' : scope.row.Suggest == '中度' || scope.row.Suggest == '重点关注' ? 'moderate' : scope.row.Suggest == '重度' || scope.row.Suggest == '密切陪护' ? 'severe' : scope.row.Suggest == '良好' || scope.row.Suggest == '正常交流' ? 'well' : scope.row.Suggest == '严密守护' ? 'urgency': ''">
                        {{ scope.row.Suggest }}
                      </span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="报告" align="center">
                <template slot-scope="scope">
                  <span @click="OpenCenterDialogVisible(scope.row)" :style="scope.row.Percentage != 0 ? 'padding:20px; color: rgba(36, 153, 255, 1); cursor:pointer;' : 'padding:20px; color: rgba(166, 166, 166, 1); cursor:pointer;'">查看</span>
                </template>
              </el-table-column>
              <el-table-column Percentage label="测试进度">
                <template slot-scope="scope" center>
                  <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.Percentage"></el-progress>
                </template>
              </el-table-column>
              <el-table-column property="Source" label="来源"></el-table-column>
              <el-table-column property="State" label="状态"></el-table-column>

              <el-table-column label="操作" width="200">
                <template slot-scope="scope" align="center">
                  <span v-if="scope.row.State == '需要访谈'"  style="padding:20px;color: rgba(36, 153, 255, 1);cursor: pointer;" @click="openInterviewVisible(scope.row)">访谈跟进</span>
                  <span v-if="scope.row.State == '已跟进' || scope.row.State == '已上报'" style="padding:20px;color: rgba(36, 153, 255, 1);margin-left: 8px;cursor: pointer;" @click="--(scope.row)" >查看跟进</span>
                  <span v-if="(scope.row.c3==false && scope.row.State == '无需访谈'  && (scope.row.Result == '轻度'|| scope.row.Result == '良好')) || scope.row.c1 == '4'" style="padding:20px ;color: rgba(36, 153, 255, 1); margin-left: 8px;cursor: pointer;" @click="AddCombineResult(scope.row)">加入访谈</span >
                  <span v-if="scope.row.c1 == '2' && scope.row.InterviewConditionName == '-' && scope.row.Source == '手动加入' && scope.row.c3==false" style="padding:20px ;color: rgba(36, 153, 255, 1); margin-left: 8px;cursor: pointer;"  @click="DeleteCombineResult(scope.row)">取消访谈</span>
                </template>
              </el-table-column>


            </el-table>
            <el-pagination  style="margin-top:10px;float: right;" background layout="total,prev,pager,next,jumper" :page-size="10" :total="AllCount" @current-change="current_change" :hide-on-single-page="wpppd">
            </el-pagination>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      xaukm:false,
      zhungtai:'',
      visible: false,
      c3:false,//判断是否访谈
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      entity:sessionStorage.getItem('entity'),
      zhedie: true,
      chongzhiDeptID: '',
      Determine_random: true, //判断是否点击随机访谈
      gysjhxss: [], //分页后端要的总数据
      gysjhx: [], //分页后端要的十条数据
      listCountS: [],
      Random: 0,
      SaveFlg: 1,
      data: [],
      bans: false,
      DeptID: '',
      optionsnew: [],
      GetSubjectPublishList: [],
      wdisabled: true,
      VsitorNameList: [],
      value1: '',
      wUserID: '',
      fieldObj: {},
      fieldArray: [], //表单字段集合
      loading: true,
      wpppd: true,
      testcount: { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 },
      interviewcount: { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 },
      tableList: [],
      PaperList: [],
      Paperhead: {Name: '',Sex: '',DeptName: '',UserID: '',Result: '',PublishID: '',Remark: '',},
      interviewfrom: {val1: '',val2: '',val3: [],val4: '',val5: [],val6: '',val7: [],val8: [],val9: '',val10: '',val11: '',val12: [],val13: '',val14: '',val15: '',val16: [],val17: '',val18: '',val19: '',val20: '',val21: ''},
      centerDialogVisible: false, //查看测评量表
      interviewVisible: false, //访谈跟进
      interviewVisible2: false, //访谈跟进查看修改
      ruleForm: {UserID: '',General: '',PublishSubject: '',state: '',interview: '',progress: '',Source: '-1',},
      options: [
        {value:'良好', label: '良好'},
        {value:'轻度', label: '轻度'},
        {value:'中度', label: '中度'},
        {value:'较重', label: '较重'},
        {value:'重度', label: '重度'},
      ],
      options2: [
        {value:'已跟进', label: '已跟进'},
        {value:'需要访谈', label: '需要访谈'},
        {value:'无需访谈', label: '无需访谈'},
        {value:'已上报', label: '已上报'},
        {value:'未上报', label: '未上报'},
      ],
      options3: [
        {value:'良好',label:'良好'},
        {value:'轻度',label:'轻度'},
        {value:'中度',label:'中度'},
        {value:'较重', label:'较重'},
        {value:'无法确定',label:'无法确定'},
        {value:'重度', label:'重度'},
      ],
      options4: [
        {value:'1', label:'已完成'},
        {value:'0', label:'未完成'},
      ],
      PageInfo: {CurrentIndex: 0,PageSize: 10,PageIndex: 0,TotleCount: 0,TotlePageCount: 0},
      AllCount: -1,
    };
  },
  mounted: function () {
    this.GettableList();
    this.GetSubjectPublish();
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: '',content: '',}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
      }
    });
  },
  methods: {
    wjsb() {
      this.$Http_Post('EmphasisClarification/VerifyReported', { pageSize: this.PageInfo.PageSize, pageIndex: this.PageInfo.PageIndex, UserID: this.ruleForm.UserID, General: this.ruleForm.General, PublishSubject: this.ruleForm.PublishSubject, state: this.ruleForm.state, interview: this.ruleForm.interview, progress: this.ruleForm.progress, DeptID: this.DeptID, Source: this.ruleForm.Source, Random: this.Random }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.Paperhead.Remark = ''
        })
        .catch(_ => {
        });
    },
    whandleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.Paperhead.Remark = ''
        })
        .catch(_ => {
        });
    },

    zhedies() {
      this.zhedie = false;
    },
    zhankai() {
      this.zhedie = true;
    },
    Randomfun() {
      this.loading = true;
      this.Determine_random = false;
      this.Random = 1;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.ruleForm.Source = '-1';
      this.RandomInterviews();
    },
    RandomInterviews() {
      this.$Http_Post('/EmphasisClarification/RandomInterviews', {PublishID: this.ruleForm.PublishSubject,UserIDList: this.gysjhx,UserIDListTwo: this.GetTableList,DeptID:this.DeptID,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableList = res.Data.list1;
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.AllCount = res.Counts;
        }else{
          this.loading = false;
          this.Global.request_failure(res.Message);

        }
      });
    },
    AddCombineResult(row) {
      this.$Http_Post('/EmphasisClarification/AddCombineResult', {
        UserID: row.UserID,
        PublishID: row.PublishID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    DeleteCombineResult(row) {
      this.$Http_Post('/EmphasisClarification/DeleteCombineResult', {
        UserID: row.UserID,
        PublishID: row.PublishID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    AddCombineResultStochastic() {
      this.visible = false;
      this.$Http_Post('/EmphasisClarification/AddCombineResultStochastic', {
        UserIDList: this.GetTableList,
        PublishID: this.ruleForm.PublishSubject,
        DeptID:this.DeptID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
          this.Determine_random = true;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 &&  obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID: dt[dt.length - 1],content: ''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    getVsitorNameList(query) {
      if (query !== '') {
        this.loadingstart = true;
        this.$Http_Post('ConsultSubscribe/GetBlacklistNameList', {Query: query}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingstart = false;
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (this.VsitorNameList[index].UserID == this.wUserID) {
          this.addInformationShow = true;
          this.DeptName = this.VsitorNameList[index].DeptName;
        }
      }
    },

    getFieldData() {
      let response = this.fieldArray;
      for (let i = 0; i < response.length; i++) {
        let item = response[i];
        if (item.HtmlElements === '复选框') {
          this.$set(this.fieldObj, item.ShowName, []);
        } else {
          this.$set(this.fieldObj, item.ShowName, item.showValue);
        }
      }
    },

    submitForm(formName) {//提交验证
      this.interviewVisible = false;
      this.$Http_Post('CrisisWarning/AddingConfigForm', {userid: this.Paperhead.UserID,createtime: this.value1,form: this.fieldArray,TableName: '新生心理预警访谈记录表',PublishID: this.Paperhead.PublishID,Modify: false,Remark: this.Paperhead.Remark,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Paperhead.Remark = '';
          this.Global.request_successful(res.Message);
          this.GettableList();
        }
      });
    },

    submitForm2(formName) {
      //提交修改
      (this.interviewVisible = false),
        this.$Http_Post('CrisisWarning/AddingConfigForm', {userid: this.Paperhead.UserID,createtime: this.value1,form: this.fieldArray,TableName: '新生心理预警访谈记录表',PublishID: this.Paperhead.PublishID,Modify: true,Remark: this.Paperhead.Remark,}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.interviewVisible2 = false;
            this.Global.request_successful(res.Message);
            this.GettableList();
            this.Paperhead.Remark = '';
          }
        });
    },

    wppgai() {
      this.Paperhead.Remark = '';
      (this.wdisabled = true((this.interviewfrom.val1 = ''))),
        (this.interviewfrom.val2 = ''),
        (this.interviewfrom.val3 = []),
        (this.interviewfrom.val4 = ''),
        (this.interviewfrom.val5 = []),
        (this.interviewfrom.val6 = ''),
        (this.interviewfrom.val7 = []),
        (this.interviewfrom.val8 = []),
        (this.interviewfrom.val9 = ''),
        (this.interviewfrom.val10 = ''),
        (this.interviewfrom.val11 = ''),
        (this.interviewfrom.val12 = []),
        (this.interviewfrom.val13 = ''),
        (this.interviewfrom.val14 = ''),
        (this.interviewfrom.val15 = ''),
        (this.interviewfrom.val16 = []),
        (this.interviewfrom.val17 = ''),
        (this.interviewfrom.val18 = ''),
        (this.interviewfrom.val19 = ''),
        (this.interviewfrom.val20 = ''),
        (this.interviewfrom.val21 = '');
    },

    resetForm() {
      this.Determine_random = true;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.PublishSubject = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.DeptID = this.chongzhiDeptID;
      this.ruleForm.Source = '-1';
      this.c3 = false;
      this.GettableList();
    },

    openReport(a) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },

    openInterviewFormVisible(row) {//查看修改
      this.zhungtai = row.State;
      this.fieldArray = [];
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Result = row.Result;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.$Http_Post('CrisisWarning/GetFormView',{TableName: '新生心理预警访谈记录表',PublishID: this.Paperhead.PublishID,UserID: this.Paperhead.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.sys_Forms;
          this.value1 = res.Data.createtime;
          this.Paperhead.Remark = res.Data.Remark;
          this.interviewVisible2 = true;
        }
      });
    },

    openInterviewVisible(row) {//新增
      this.fieldArray = [];
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Result = row.Result;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.value1 = '';
      this.$Http_Post('CrisisWarning/GetPageList', { TableName: '新生心理普测访谈记录表'}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.FormConfigurations;
          this.SaveFlg = res.Data.SaveFlg;
          this.interviewVisible = true;
        }
      });
    },

    OpenCenterDialogVisible(row) {
      if (row.Percentage != 0) {
        this.centerDialogVisible = true;
        this.Paperhead.Name = row.RealName;
        this.Paperhead.Sex = row.Sex;
        this.Paperhead.DeptName = row.DeptName;
        this.Paperhead.UserID = row.UserID;
        this.$Http_Post('EmphasisClarification/GetPaperList', {UserID: row.UserID,PublishID: row.PublishID,}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.PaperList = res.Data;
          }
        });
      }
    },
    GetSubjectPublish() {
      this.$Http_Post('EmphasisClarification/GetSubjectPublish').then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.GetSubjectPublishList = res.Data;
        }
      });
    },
    ExportTableList() {
      this.daochu = true;
      this.$Http_Post('EmphasisClarification/ExportTableList', {UserID: this.ruleForm.UserID,General: this.ruleForm.General,PublishSubject: this.ruleForm.PublishSubject,state: this.ruleForm.state,interview: this.ruleForm.interview,progress: this.ruleForm.progress,DeptID: this.DeptID,Source: this.ruleForm.Source}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.daochu = false;
          this.Global.request_successful(res.Message);
          window.location.href = res.Data;
        } else {
          this.daochu = false;
          this.Global.request_failure(res.Message);
        }
      });
    },
    GettableList(a) {
      this.xaukm = true;
      this.testcount = { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0};
      this.interviewcount = {one: 0,tow: 0,three: 0,four: 0,five: 0,six: 0};
      this.loading = true;
      if (a == 1) {
        this.PageInfo.PageIndex = 1;
      }
      this.$Http_Post('/management/emphasisclarification/gethytablelist', {pageSize: this.PageInfo.PageSize,pageIndex: this.PageInfo.PageIndex,UserID: this.ruleForm.UserID,General: this.ruleForm.General,PublishSubject: this.ruleForm.PublishSubject,state: this.ruleForm.state,interview: this.ruleForm.interview,progress: this.ruleForm.progress,DeptID: this.DeptID,Source: this.ruleForm.Source,Random: this.Random}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xaukm = false;
          if(res.Data.list1.length > 0){
            this.c3 = res.Data.list1[0].c3
          }
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.tableList = res.Data.list1;
          this.AllCount = res.Counts;
          let count = res.Data.count;
          this.ruleForm.PublishSubject = res.Data.PublishID;
          let count1 = res.Data.count1;
          this.testcount.one = 0;
          for (let index = 0; index < count.length; index++) {
            if (count[index].key == '重度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.tow = parseInt(count[index].count);
            }
            if (count[index].key == '中度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.three = parseInt(count[index].count);
            }
            if (count[index].key == '轻度') {
              this.testcount.four = parseInt(count[index].count);
            }
            if (count[index].key == '良好') {
              this.testcount.five = parseInt(count[index].count);
            }
            if (count[index].key == '重度且紧急') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.six = parseInt(count[index].count);
            }
          }
          this.interviewcount.one = 0;
          for (let index = 0; index < count1.length; index++) {
            if (count1[index].key == '较重') {
              this.interviewcount.one =  this.interviewcount.one + count1[index].count;
              this.interviewcount.tow = count1[index].count;
            }
            if (count1[index].key == '中度') {
              this.interviewcount.one =  this.interviewcount.one + count1[index].count;
              this.interviewcount.three = count1[index].count;
            }
            if (count1[index].key == '轻度') {
              this.interviewcount.four = count1[index].count;
            }
            if (count1[index].key == '良好') {
              this.interviewcount.five = count1[index].count;
            }
            if (count1[index].key == '重度') {
              this.interviewcount.one = this.interviewcount.one + count1[index].count;
              this.interviewcount.six = count1[index].count;
            }
          }
        } else {
          this.loading = false;
        }
      });
    },
    handleCurrentChange: function(val) {
      this.SelectObj = val;
    },
    current_change: function(currentPage) {
      if (this.Determine_random) {
        this.PageInfo.PageIndex = currentPage;
        this.GettableList();
      } else {
        this.gysjhx = this.GetTableList.slice(
          currentPage * 10 - 10,
          currentPage * 10
        );
        this.RandomInterviews();
      }
    },
  },
};
</script>
<style>
.EmphasisClarification .el-header {height: auto !important;background-color: rgba(255, 255, 255, 1);}
.EmphasisClarification .el-main {margin-top: 20px;background-color: rgba(255, 255, 255, 1);}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button { -webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}
.EmphasisClarification .boxs {background: rgba(245, 247, 250, 1);margin-top: 15px;}
.EmphasisClarification .boxs button {float: right;margin-right: 20px;}
.EmphasisClarification .mild {padding: 0px 15px;background: rgba(29, 154, 255, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(29, 154, 255, 1);}
.EmphasisClarification .moderate {padding: 0px 15px;background: rgba(255, 193, 23, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(255, 193, 23, 1);}
.EmphasisClarification .severe {padding: 0px 15px;background: rgba(255, 141, 26, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(255, 141, 26, 1);}
.EmphasisClarification .well {padding: 0px 15px;background: rgba(21, 191, 109, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(21, 191, 109, 1);}
.EmphasisClarification .urgency {padding: 0px 15px;background: rgba(191, 41, 21, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgb(248, 4, 4);}
.EmphasisClarification .colrowstyle {height: 40px;line-height: 40px;color: rgba(92, 92, 92, 1);background: rgba(245, 247, 250, 1);}
.EmphasisClarification .colrowspanstyle {line-height: 40px;border-top: 1px solid rgba(225, 226, 227, 1);border-left: 1px solid rgba(225, 226, 227, 1);border-right: 1px solid rgba(225, 226, 227, 1);}
.EmphasisClarification .colrowspanbottomstyle {border-bottom: 1px solid rgba(225, 226, 227, 1);}
.EmphasisClarification .noneborder input {border: 0px;}
.EmphasisClarification .bottomborder input {border-bottom: 1px solid rgba(166, 166, 166, 1);}
.EmphasisClarification .el-dialog h2 {padding-top: 14px;margin-bottom: 14px;}
.EmphasisClarification .el-dialog .标题 {width: 100%;}
.EmphasisClarification .el-dialog .el-form > div { margin-left: 14px;}
.EmphasisClarification .el-dialog .输入框 input {width: initial;width: 400px;}
.EmphasisClarification .el-dialog .el-input__inner {width: initial;}
.EmphasisClarification .el-dialog .el-form-item__label {width: initial !important;display: inline-block;text-align: right;min-width: 90px;text-align: left;}
.EmphasisClarification .el-dialog .el-form-item__content {margin-left: initial !important;display: inline-block;}
.EmphasisClarification .el-textarea__inner{height: 100%;}
.EmphasisClarification .el-dialog .ccc .el-form-item__content {width: 50%;}
.el-dialog .复选框 .el-form-item__label {min-width: 40px !important;}
.EmphasisClarification .el-dialog .el-form-item {margin-bottom: 0px;}
.el-dialog .填空题,.单选题,.时间选择,.文本域 {padding: 6px;border: 1px solid rgb(235, 235, 235);margin-top: 4px;}
.EmphasisClarification .el-form-item {margin-left: 20px;}
.el-table--enable-row-transition .el-table__body td {text-align: center;}
</style>
